
import { UserModule } from '@/store/modules/user';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'SidebarLogo'
})
export default class extends Vue {
  private title = '管理后台';
  private isRefresh = true
  private clickable = false
  private defaultLogo = require('@/assets/images/logo.png')
  get logo() {
    return UserModule.getCompany ? UserModule.getCompany.logo : '';
  }
  private indexRefresh() {
    let vipLevel:string = '9';
    if (UserModule.company) {
      if (parseInt(UserModule.getCompanyId) !== 0) {
        vipLevel = UserModule.company.vip_level;
      }
      if (parseInt(vipLevel.substring(0, 1)) !== 1) {
        this.clickable = true;
        this.$router.push({
          path: '/Index'
        });
      } else {
        this.clickable = false;
        let arr = (this.$router as any).options.routes.filter((element:any) => {
          return (element.path === '/' && element.meta && !element.meta.hidden);
        });
        if (arr && arr.length > 0) {
          this.clickable = true;
          this.$router.push({
            path: '/Index'
          });
        }
      }
    } else {
      this.clickable = false;
    }
  }
private showBack=false;
private showAgent=false;
created() {
  let vipLevel:string = '9';
  if (parseInt(UserModule.getCompanyId) !== 0 && UserModule.company) {
    vipLevel = UserModule.company.vip_level;
  }
  if (parseInt(vipLevel.substring(0, 1)) !== 1 && parseInt(vipLevel.substring(0, 1)) !== 9 && parseInt(vipLevel.substring(1, 2)) !== 1) {
    this.showBack = true;
  } else {
    this.showBack = false;
  }
  if (parseInt(UserModule.getUserInfo.is_agent) === 1) {
    this.showAgent = true;
  } else {
    this.showAgent = false;
  }
}
}
